module.exports = __webpack_public_path__ + "static/media/close_icon_white_3.493677f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_icon_white_3.svg
// module id = 503
// module chunks = 0